import React, {useState, useEffect, useMemo} from "react";
import { useTable, usePagination, useSortBy, useExpanded, useResizeColumns, useFlexLayout } from "react-table";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'

import {AVAILABLE_GIFT_CODES_COLUMNS}  from "./columns";

import ReactTablePagination from '@/shared/components/table/components/ReactTablePagination';
import UploadGiftCodesModal  from "./UploadGiftCodesModal";
import { Row, Col } from 'reactstrap';


import {reducer, useEffectToDispatch, fetchApiData, initialState, TableFilter, Sorting} from "@/shared/apiTableHelper"
import ConfirmPopup from "../../../../shared/components/modal/confirmModal/ConfirmPopup";
import axios from "axios";
import {useDispatch, sendFlashMessage} from "@/shared/components/flash"

const queryClient = new QueryClient()

const DataTable = ({merchant}) => {

    const [filter, setFilter] = useState({ keyword:'', type:'test'});
    const [useFilter, setUseFilter] = useState(false);
    const [isOpen, setOpen] = useState(false)
    const [isOpenConfirmRemove, setIsOpenConfirmRemove] = useState(false)
    const [trigger, setTrigger] = useState( 0 );
    const dispatchFlash = useDispatch()

    const toggle = () => {
        setOpen(prevState => !prevState)
    }

    const toggleConfirmRemove = () => {
        setIsOpenConfirmRemove(prevState => !prevState)
    }

    let columns = useMemo( () => AVAILABLE_GIFT_CODES_COLUMNS, [])

    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter, queryPageSortBy, queryTrigger }, dispatch] =
    React.useReducer(reducer, initialState);

    const removeCodes = () => {
        const apiUrl = `/merchant/${merchant.id}/giftcode-test`;
        axios
          .delete(apiUrl)
          .then((res) => {
              if (res.status == 200) {
                  toggleConfirmRemove()
                  setTrigger(Math.floor(Date.now() / 1000))
                  dispatchFlash(sendFlashMessage('Giftcodes removed successfully', 'alert-success'))
              }
          })
          .catch((error) => {
              dispatchFlash(sendFlashMessage('Error while deleting codes', 'alert-danger'))
              console.log(error)
          });
    }

    const apiUrl = `/merchant/${merchant.id}/giftcode`

    const { isLoading, error, data, isSuccess } = useQuery(
        ['giftcodes', apiUrl, queryPageIndex, queryPageSize, queryPageFilter, queryPageSortBy, queryTrigger],
        () => fetchApiData(
            {
                url: apiUrl,
                page: queryPageIndex,
                size: queryPageSize,
                filter,
                sortby: queryPageSortBy,
                trigger: queryTrigger
            }
        ),
        {
            keepPreviousData: true,
            staleTime: Infinity,
        }
    );

    const totalPageCount = Math.ceil(totalCount / queryPageSize)

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        setPageSize,
        state: { pageIndex, pageSize, sortBy }
    } = useTable({
        columns,
        data: data ? data.results : [],
        initialState: {
            pageIndex: queryPageIndex,
            pageSize: queryPageSize,
            sortBy: queryPageSortBy
        },
        manualPagination: true, // Tell the usePagination
        pageCount: data ? totalPageCount : null,
        autoResetSortBy: false,
        autoResetExpanded: false,
        autoResetPage: false,
    },
    useSortBy,
    useExpanded,
    usePagination,
    useResizeColumns,
    useFlexLayout
    );
    // const [statusFilterValue, setStatusFilterValue] = useState("");
    const manualPageSize = []

    useEffectToDispatch( dispatch, {pageIndex, pageSize, gotoPage, sortBy, filter, data, useFilter, trigger} );

    if (error) {
        return <p>Error: {JSON.stringify(error)}</p>;
    }

    if (isLoading) {
        return <p>Loading...</p>;
    }

    if(isSuccess)
    return (
            <>
                <div className='table react-table available-table'>
                    <Row>
                        <Col md={10}>
                            <TableFilter filter={filter} setFilter={setFilter} setUseFilter={setUseFilter} config={{label:'codes', sku:true, type:'test'}} />
                        </Col>
                        <Col md={2} className="text-right pr-0">
                            <div style={{maxWidth:'205px'}}
                                 className="btn btn-primary account__btn account__btn--small"
                                 onClick={()=>toggle()} >
                                 Upload Test Gift Codes
                            </div>
                            <div style={{maxWidth:'205px'}}
                                 className="btn btn-primary account__btn account__btn--small"
                                 onClick={()=>toggleConfirmRemove()} >
                                Remove Test Gift Codes
                            </div>
                        </Col>
                    </Row>
                    <table {...getTableProps()} className="table">
                        <thead>
                            {headerGroups.map( (headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map( (column, i) => (
                                        <th className={`cell-column-${i}`} {...column.getHeaderProps(column.getSortByToggleProps())}>
                                            {column.render('Header')}
                                            {column.isSorted ? <Sorting column={column} /> : ''}
                                            <div
                                                {...column.getResizerProps()}
                                                className={`resizer ${
                                                    column.isResizing ? 'isResizing' : ''
                                                }`}
                                            />
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody className="table table--bordered" {...getTableBodyProps()}>
                            {page.map( row => {
                                prepareRow(row);
                                // console.log(row)
                                const subCount = (row.id.match(/\./g) || []).length
                                const paddingCount = subCount > 0 ? Number(subCount) + 2 : 0;
                                // console.log(subCount)
                                return (
                                    <tr {...row.getRowProps()}>
                                        {
                                            row.cells.map( (cell, i) => {
                                                // console.log(cell)
                                                return <td className={`cell-column-${i}`} {...cell.getCellProps()}><span className={cell.column.Header==='#' ? `pl-${paddingCount}` : ''}>{cell.render('Cell')}</span></td>
                                            })
                                        }
                                    </tr>
                                )
                            })}
                        </tbody>
                        {/* <tfoot>
                            {footerGroups.map( (footerGroup) => (
                                <tr {...footerGroup.getFooterGroupProps()}>
                                    {footerGroup.headers.map( column => (
                                        <th {...column.getFooterProps()}>{column.render('Footer')}</th>
                                    ))}
                                </tr>
                            ))}
                        </tfoot> */}
                    </table>
                </div>
                {/* <UploadGiftCodesModal isOpen={isOpen} setOpen={setOpen} toggle={toggle} data={data}  /> */}
                {(rows.length > 0) && (
                    <>
                        <ReactTablePagination
                        page={page}
                        gotoPage={gotoPage}
                        previousPage={previousPage}
                        nextPage={nextPage}
                        canPreviousPage={canPreviousPage}
                        canNextPage={canNextPage}
                        pageOptions={pageOptions}
                        pageSize={pageSize}
                        pageIndex={pageIndex}
                        pageCount={pageCount}
                        setPageSize={setPageSize}
                        manualPageSize={manualPageSize}
                        dataLength={totalCount}
                        />
                        <div className="pagination justify-content-end mt-2">
                            <span>
                            Go to page:{' '}
                            <input
                                type="number"
                                value={pageIndex + 1}
                                onChange={(e) => {
                                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                gotoPage(page);
                                }}
                                style={{ width: '100px' }}
                            />
                            </span>{' '}
                            <select
                            value={pageSize}
                            onChange={(e) => {
                                setPageSize(Number(e.target.value));
                            }}
                            >
                            {[10, 20, 30, 40, 50].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                                </option>
                            ))}
                            </select>
                        </div>
                    </>
                )}
                <UploadGiftCodesModal isOpen={isOpen} toggle={toggle} data={data} setTrigger={setTrigger} test={1} />
                <ConfirmPopup isOpen={isOpenConfirmRemove} toggle={toggleConfirmRemove} action={removeCodes}
                message={`Are you sure you want to remove all unredeemed test codes?<br/> WARNING: This cannot be undone!`}/>
            </>
    )
}

const TableWrapper = ({merchant}) => {
    return (
        <QueryClientProvider client={queryClient}>
            <DataTable merchant={merchant} />
        </QueryClientProvider>
    )
}

export default TableWrapper;


